module.exports = __webpack_public_path__ + "static/photo-4d185d941a9f97ca51c0d4f45d9c4e2c.jpg";